import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import parseResponseToOptions, { parseMVIdOptions } from '../../utils/parseResponseToOptions';
import { parseOptionsWithUpdatedDate } from '../../utils/parseResponseToOptions.jsx';
import UpdateMV from './component';

class UpdateMVContainer extends Component {
  constructor() {
    super();
    this.state = {
      disabled: true,
      codes: [],
      loading: false,
      formData: null,
      manufacturerId: null,
      variantId: null,
      offerPrice: 0,
      mrp: 0,
      vendorPrice: 0,
      isActive: 0,
      updateLoading: false
    };
  }
  componentDidMount() {
    this.setState({
      loading: true
    });

    this.props.getDataFromAPI(
      '/mvs/all/codes',
      'GET',
      undefined,
      response => {
        this.setState({
          codes: response.list,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch manufacturer variant codes');
        this.setState({
          loading: false
        });
      }
    );
  }

  onChangeOfMVId = (event, data) => {
    const mvId = data.value;

    // fetch product details
    this.setState({
      loading: true,
      disabled: true
    });

    this.props.getDataFromAPI(
      `/mvs?mvId=${mvId}`,
      'GET',
      undefined,
      response => {
        const mvDetails = response.list[0];
        this.setState({
          mvId: mvDetails.id,
          manufacturerId: mvDetails.manufacturer_id,
          variantId: mvDetails.variant_id,
          offerPrice: mvDetails.offer_price,
          mrp: mvDetails.mrp,
          vendorPrice: mvDetails.vendor_price,
          isActive: mvDetails.is_active
        });

        // get forms
        this.props.getDataFromAPI(
          '/form/mv/dropdowns',
          'GET',
          undefined,
          response => {
            this.setState({
              formData: response,
              loading: false,
              disabled: false
            });
          },
          err => {
            console.log(err);
            toastr.error('Failed', 'Unable to fetch options');
            this.setState({
              loading: false,
              disabled: false
            });
          }
        );
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch manufacturer variant details');
        this.setState({
          loading: false
        });
      }
    );
  };

  // fields handler
  onChangeOfManufacturerId = (event, data) => {
    this.setState({
      manufacturerId: data.value
    });
  };

  onChangeOfVariantId = (event, data) => {
    this.setState({
      variantId: data.value
    });
  };

  onChangeOfMrp = event => {
    console.log(event.target.value);
    this.setState({
      mrp: event.target.value
    });
  };

  onChangeOfOfferPrice = event => {
    this.setState({
      offerPrice: event.target.value
    });
  };

  onChangeOfVendorPrice = event => {
    this.setState({
      vendorPrice: event.target.value
    });
  };

  onChangeOfStatus = (event, data) => {
    this.setState({
      isActive: parseInt(data.value, 10) ? 1 : 0
    });
  };

  handleSubmit = () => {
    this.setState({
      loading: true,
      disabled: true,
      updateLoading: true
    });

    const { mvId, manufacturerId, variantId, offerPrice, mrp, vendorPrice, isActive } = this.state;

    const payload = {
      mvId,
      manufacturerId,
      variantId,
      offerPrice,
      mrp,
      vendorPrice,
      isActive
    };

    this.props.getDataFromAPI(
      '/mvs/update',
      'PATCH',
      payload,
      response => {
        toastr.success('Successful', 'Updated Manufacturer Variant');
        this.setState({
          loading: false,
          disabled: false,
          updateLoading: false
        });
        return this.props.history.push('/products/actions');
      },
      err => {
        this.setState({
          loading: false,
          disabled: false,
          updateLoading: false
        });
        toastr.error('Error', err);
      }
    );
  };

  render() {
    // console.log('---------------------------------------------');
    // console.log('state', this.state);

    const formData = this.state.formData;

    return (
      <UpdateMV
        disabled={this.state.disabled}
        loading={this.state.loading}
        mvCodesDD={parseMVIdOptions(this.state.codes)}
        onChangeOfMVId={this.onChangeOfMVId}
        manufacturersDD={parseOptionsWithUpdatedDate((formData && formData.manufacturers) || [])}
        variantsDD={parseOptionsWithUpdatedDate((formData && formData.variants) || [])}
        selectedManufacturer={this.state.manufacturerId}
        selectedVariant={this.state.variantId}
        mrp={this.state.mrp}
        offerPrice={this.state.offerPrice}
        vendorPrice={this.state.vendorPrice}
        isActive={this.state.isActive}
        onChangeOfMrp={this.onChangeOfMrp}
        onChangeOfOfferPrice={this.onChangeOfOfferPrice}
        onChangeOfVendorPrice={this.onChangeOfVendorPrice}
        onChangeOfManufacturerId={this.onChangeOfManufacturerId}
        onChangeOfVariantId={this.onChangeOfVariantId}
        onChangeOfStatus={this.onChangeOfStatus}
        submitLoading={this.state.updateLoading}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

export default withRouter(
  connect(null, {
    getDataFromAPI
  })(UpdateMVContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/UpdateManufacturerVariant/container.jsx